import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { GlobalVar } from '../../globals/global-var';
import { SelfService } from '../../services/self.service';

@Component({
  selector: 'app-change-pwd',
  templateUrl: './change-pwd.component.html',
  styleUrls: ['./change-pwd.component.css']
})
export class ChangePwdComponent implements OnInit {

  changepwdForm = this.fb.group({
    password: ['', Validators.required],
    passwordCheck: ['', Validators.required],
  });

  constructor(private selfService: SelfService, private fb: FormBuilder) { }

  ngOnInit(): void {
  }

  putChangepwd(changepwdData: any) {
    if (confirm("確定修改密碼??") == true) {
      this.selfService.putChangePwdApi( changepwdData)
        .subscribe(
          result => {
            alert(result.message);
          },
          err => {
            alert(JSON.stringify(err.error));
          }
        );
    }
  }

}
